import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import Pagination from 'react-js-pagination'

import Box from '../components/Layout/Box'
import ButtonStrip from '../components/Layout/ButtonStrip'
import BoxButton from '../components/Layout/BoxButton'
import ModalFilter from '../components/Solicitudes/ModalFilter'
import ModalDelete from '../components/Solicitudes/ModalDelete'

import {
    getSolicitudes,
	toggleSelectItem,
	toggleSelectAllItems,
	filterSolicitudes,
	setOrderBy,
	showHideModalDelete,
	deleteSolicitudes,
    changeRecordsToShow,
    showHideModalFilter,

} from '../actions/solicitudes'




import history from '../utils/history'
import store from '../utils/store'


import { extractKeyValue } from '../utils/helpers'

// export const tableCols = [
//     { id: 1, caption: 'Id', value: 'id', type: 'number', format: '', width: '5%', LinkToEdit: true },
//     { id: 2, caption: 'Asignada a', value: 'responsable_compras', type: 'string', format: '', width: '15%' },
//     { id: 3, caption: 'Tipo', value: 'tipo', type: 'string', format: '', width: '15%' },
//     { id: 4, caption: 'Area', value: 'area', type: 'string', format: '', width: '10%' },
//     { id: 5, caption: 'Proyecto/Evento/Actividad', value: 'proyecto_evento', type: 'string', format: '', width: '30%' },
//     { id: 6, caption: 'Fecha creación', value: 'fecha_creacion', type: 'datetime', format: 'YYYY-MM-DD HH:mm:ss', width: '10%' },
//     { id: 7, caption: 'Estado', value: 'estado', type: 'string', format: '', width: '10%' },
// ]


export function findValues(c, x) {

    const enums = store.getState().common.get('enums').toJS()    
    let value = x.getIn(c.value.split('.'))

    if (c.value === 'estado') {
        value = enums.solicitudes.estados[value]
    } else if (c.value === 'tipo') {
        value = enums.solicitudes.tipos[value].caption
    }
	return value
}

class Solicitudes extends Component {
    
    componentWillMount() {
        this.props.getSolicitudes(1);
    }

	render() {

        const { solicitudes, orderBy, page, totalRecords, showRecords, enums } = this.props
        
        const tableCols = [
            { id: 1, caption: 'Id', value: 'id', type: 'string', format: '', width: '5%', LinkToEdit: true },
            { id: 2, caption: 'Asignada a', value: 'responsable_compras', type: 'string', format: '', width: '15%' },
            { id: 3, caption: 'Tipo', value: 'tipo', type: 'string', format: '', width: '15%', enums: extractKeyValue(enums.solicitudes.tipos, 'caption') },
            { id: 4, caption: 'Area', value: 'area', type: 'string', format: '', width: '10%' },
            { id: 5, caption: 'Proyecto/Evento/Actividad', value: 'proyecto_evento', type: 'string', format: '', width: '35%' },
            { id: 6, caption: 'Fecha creación', value: 'fecha_creacion', type: 'datetime', format: 'YYYY-MM-DD HH:mm:ss', width: '10%' },
            { id: 7, caption: 'Estado', value: 'estado', type: 'string', format: '', width: '10%', enums: extractKeyValue(enums.solicitudes.estados) },
        ]        

        const boxActions = [
            // <BoxButton key="ba[0][0]" name="trash" onClick={ e => this.props.showHideModalDelete(true, `Esta seguro que desea anular las solicitudes seleccionadas?`, () => this.props.deleteSolicitudes()) } disabled={ solicitudes.filter(x => x.get('selected')).count() === 0 } danger title="Anular solicitud" />,
            <BoxButton key="ba[0][1]" name="filter" onClick={ e => this.props.showHideModalFilter(true, tableCols) } title="Filtro"/>
        ]

        const pagination = <Pagination
                            activePage={ page }
                            itemsCountPerPage={ showRecords }
                            totalItemsCount={ totalRecords }
                            pageRangeDisplayed={ 10 }
                            onChange={ (pg) => this.props.getSolicitudes(pg)  }
                            firstPageText={ <FontAwesome name="angle-double-left" /> }
                            prevPageText={ <FontAwesome name="angle-left" /> }
                            nextPageText={ <FontAwesome name="angle-right" /> }
                            lastPageText={ <FontAwesome name="angle-double-right" /> }
                        />


		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Listado de solicitudes" stretch>
                        <ButtonStrip 
                            actions={ boxActions } 

                            totalRecords={ totalRecords }
                            showRecords={ showRecords }
                            changeRecordsToShow={ (records) => this.props.changeRecordsToShow(records) }
                            pagination={ pagination }

                        />

                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-solicitudes">
                                <thead>
                                    <tr>
                                        <th width="20">
                                            <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectAllItems(e.target.checked) } checked={ solicitudes.filter(x => x.get('selected')).count() > 0 && solicitudes.filter(x => x.get('selected') && x.get('visible')).count() >= solicitudes.filter(x => x.get('visible')).count() } />
                                        </th>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.width}` }
                                                return (
                                                    <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) } className={ (orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>{ x.caption }</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        solicitudes.filter(x => x.get('visible')).count() > 0 ? solicitudes.filter(x => x.get('visible')).map(x => {
                                            return (
                                                <tr key={ `tr1[${x.get('id')}]` } className={ x.get('selected') ? 'info' : '' }>
                                                    <td>
                                                        <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectItem(x.get('id'), e.target.checked) } checked={ x.get('selected') } />
                                                    </td>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findValues(c, x)
                                                            if (c.type) {
                                                                switch (c.type) {
                                                                    case 'datetime':
                                                                        value = moment(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } className='LinkToEdit' style={ style } onClick={ e => history.push(window.FOLDER + `/solicitudes/${enums.solicitudes.tipos[x.get('tipo')].url}/${x.get('id')}`) }>{ value }</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } style={ style }>{ value }</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={ tableCols.length + 1 }>No existen registros</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Box>
                </div>
                <ModalFilter />
                <ModalDelete />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        solicitudes: state.solicitudes.get('solicitudes'),
        orderBy: state.solicitudes.get('orderBy'),
        totalRecords: state.solicitudes.get('totalRecords'),
        showRecords: state.solicitudes.get('showRecords'),
        page: state.solicitudes.get('page'),
        enums: state.common.get('enums').toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSolicitudes: (page) => dispatch(getSolicitudes(page)),
		toggleSelectItem: (id, checked) => dispatch(toggleSelectItem(id, checked)),
		toggleSelectAllItems: (checked) => dispatch(toggleSelectAllItems(checked)),
		filterSolicitudes: (term) => dispatch(filterSolicitudes(term)),
		setOrderBy: (field) => dispatch(setOrderBy(field)),
		showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
		deleteSolicitudes: () => dispatch(deleteSolicitudes()),
        changeRecordsToShow: (records) => dispatch(changeRecordsToShow(records)),
        showHideModalFilter: (state, tableCols) => dispatch(showHideModalFilter(state, tableCols)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Solicitudes)


// WEBPACK FOOTER //
// ./src/containers/Solicitudes.jsx